import React from 'react';

export function PsychologyIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M31.64 14.44l-2 .8a6.01 6.01 0 00-1.34-.78l-.3-2.12c-.04-.2-.2-.34-.4-.34h-3.2c-.2 0-.36.14-.38.34l-.3 2.12c-.48.2-.94.46-1.34.78l-2-.8c-.18-.06-.4 0-.48.18l-1.6 2.76a.4.4 0 00.1.52l1.7 1.32c-.06.24-.1.52-.1.78s.02.52.06.78l-1.68 1.32c-.16.12-.2.34-.1.5l1.6 2.78c.1.18.3.24.5.18l1.98-.8c.42.32.86.58 1.36.78l.28 2.12c.04.2.2.34.4.34h3.2c.2 0 .36-.14.4-.34l.3-2.12c.48-.2.94-.46 1.34-.78l1.98.8c.18.08.4 0 .48-.18l1.6-2.78c.1-.18.06-.38-.1-.5l-1.66-1.32a5.123 5.123 0 000-1.56l1.7-1.32a.4.4 0 00.1-.52l-1.6-2.76c-.1-.18-.32-.24-.5-.18zM26 22.86a2.86 2.86 0 11-.001-5.719A2.86 2.86 0 0126 22.86z" />
      <path d="M39.88 18.12c-.86-6.54-6.46-11.72-13.06-12.1C26.54 6 26.28 6 26 6c-7.06 0-12.86 5.22-13.84 12L8.3 24.96C7.48 26.28 8.44 28 10 28h2v4c0 2.2 1.8 4 4 4h2v6h14v-9.36c5.24-2.5 8.7-8.16 7.88-14.52zm-10.1 11.14L28 30.1V38h-6v-6h-6v-8h-2.6l2.66-4.66C16.42 14.12 20.7 10 26 10c5.52 0 10 4.48 10 10 0 4.18-2.58 7.76-6.22 9.26z" />
    </svg>
  );
}
